import {SavedSearchBase, SavedSearchesGroups, SavedSearchWithId} from './saveSearchComponent-types';
import {
    AbortCategory,
    deleteWithPathVariable,
    fetchJson,
    fetchWithBody,
    postJsonWithBody
} from '../../../services/fetcher';
import {getSavedSearchApiUrl} from '../../../services/search-service';
import {SearchPageType} from '../../search-config';
import {DeleteSavedSearchFolderRequest, ShareSavedSearchFolderRequest} from './saveSearchComponent-actions';

export function fetchSavedSearches(searchPageType: SearchPageType, container: string): Promise<SavedSearchesGroups> {
    return fetchJson<SavedSearchesGroups>(getSavedSearchApiUrl(searchPageType) + '/' + container, 'GET');
}

export function postNewSavedSearch(
    searchPageType: SearchPageType,
    savedSearch: SavedSearchBase
): Promise<SavedSearchWithId> {
    return postJsonWithBody<SavedSearchWithId>(getSavedSearchApiUrl(searchPageType), JSON.stringify(savedSearch),
        AbortCategory.SAVED_SEARCH, 'no-cache');
}

export function deleteSavedSearch(
    searchPageType: SearchPageType,
    savedSearchId: number
): Promise<void> {
    return deleteWithPathVariable(getSavedSearchApiUrl(searchPageType), savedSearchId);
}

export function deleteSavedSearchFolderOnTheContainer(
    searchPageType: SearchPageType,
    body: DeleteSavedSearchFolderRequest
): Promise<void> {
    return fetchWithBody(getSavedSearchApiUrl(searchPageType), 'DELETE', JSON.stringify(body));
}

export function changeSavedSearchVisibility(
    searchPageType: SearchPageType,
    savedSearchId: number,
    shared: ShareSavedSearchFolderRequest
): Promise<void> {
    const location = getSavedSearchApiUrl(searchPageType) + '/' + savedSearchId;
    return fetchWithBody(location, 'POST', JSON.stringify(shared));
}
